// 3-level "legacy-faithful Calm" navigation taxonomy for the LMG backoffice.
// Model (doc/how-to-implement-legacy.md §1):  Group(band) → Section → Leaf.
// Only LEAVES are pages (have `path`). Sections/groups are organisational only
// → adding the middle level introduces ZERO new route/page keys.
//
// Labels reuse the EXISTING `menu.*` i18n keys (page keys preserved). Group/
// section titles use a NEW `nav.*` namespace so they can never collide with
// page keys. `adminOnly` mirrors the current `v-if="IsAdmin"` gating.

export const NAV_TREE = [
  // ── BAND 1 — งานขาย / รับชำระ (the old "Transaction" parent) ──────────────
  {
    key: "sales",
    titleKey: "nav.group.sales",
    icon: "store",
    entries: [
      {
        section: true,
        key: "sec.sellingDocs",
        labelKey: "nav.sec.sellingDocs",
        icon: "file-text",
        children: [
          { key: "transaction", labelKey: "menu.trans", path: "/lmg/v2/transaction" },
          { key: "invoice", labelKey: "menu.invoice", path: "/lmg/v2/invoice" },
        ],
      },
      {
        section: true,
        key: "sec.collections",
        labelKey: "nav.sec.collections",
        icon: "wallet",
        children: [
          { key: "payment", labelKey: "menu.payment", path: "/lmg/payment" },
          { key: "quick-payment", labelKey: "menu.quick_payment", path: "/lmg/quick-payment" },
          { key: "dms", labelKey: "menu.dms", path: "/lmg/dms" },
          { key: "cashclear", labelKey: "menu.cash_clear", path: "/lmg/cashclear", adminOnly: true },
        ],
      },
    ],
  },

  // ── BAND 2 — เอกสาร / รายงาน ──────────────────────────────────────────────
  {
    key: "documents",
    titleKey: "nav.group.documents",
    icon: "files",
    entries: [
      {
        section: true,
        key: "sec.taxDocs",
        labelKey: "nav.sec.taxDocs",
        icon: "receipt",
        children: [
          { key: "wht", labelKey: "menu.wht", path: "/lmg/wht" },
        ],
      },
      {
        section: true,
        key: "sec.reports",
        labelKey: "nav.sec.reports",
        icon: "bar-chart",
        adminOnly: true,
        children: [
          { key: "billingreport", labelKey: "menu.billing_report", path: "/lmg/billingreport", adminOnly: true },
          { key: "finance", labelKey: "menu.finance", path: "/lmg/finance", adminOnly: true },
          { key: "branch-money", labelKey: "menu.branch_money", path: "/lmg/branch-money", adminOnly: true },
        ],
      },
    ],
  },

  // ── BAND 3 — ฐานข้อมูล (admin) ────────────────────────────────────────────
  {
    key: "database",
    titleKey: "nav.group.database",
    icon: "database",
    adminOnly: true,
    entries: [
      { key: "customer", labelKey: "menu.customer", path: "/lmg/customer", icon: "users", adminOnly: true },
    ],
  },

  // ── BAND 4 — ตั้งค่า (admin) ───────────────────────────────────────────────
  {
    key: "settings",
    titleKey: "nav.group.settings",
    icon: "settings",
    adminOnly: true,
    entries: [
      {
        section: true,
        key: "sec.salesMaster",
        labelKey: "nav.sec.salesMaster",
        icon: "sliders",
        adminOnly: true,
        children: [
          { key: "insurance", labelKey: "menu.insure", path: "/lmg/insurance-v2", adminOnly: true },
          { key: "transactiontype", labelKey: "menu.ttype", path: "/lmg/transactiontype", adminOnly: true },
          { key: "commission", labelKey: "menu.comm", path: "/lmg/commission", adminOnly: true },
          { key: "person", labelKey: "menu.person", path: "/lmg/person", adminOnly: true },
        ],
      },
      {
        section: true,
        key: "sec.receivingMaster",
        labelKey: "nav.sec.receivingMaster",
        icon: "landmark",
        adminOnly: true,
        children: [
          { key: "bank", labelKey: "menu.bank", path: "/lmg/bank", adminOnly: true },
        ],
      },
    ],
  },

  // ── BAND 5 — ผู้ดูแล (admin) ───────────────────────────────────────────────
  {
    key: "admin",
    titleKey: "nav.group.admin",
    icon: "user-cog",
    adminOnly: true,
    entries: [
      { key: "user", labelKey: "menu.user", path: "/lmg/user", icon: "user", adminOnly: true },
    ],
  },
];

export default NAV_TREE;
